import {FieldGraphData} from 'src/modules/types';

export class GetFieldGasProduction {
  static readonly type = '[FieldMonitoring] Get field gas production data';

  constructor(public payload: FieldGraphData) {
  }
}
